export default __webpack_public_path__ + "static/media/service-banner.30d1eb7e.jpg";